import $ from 'jquery';
import 'arrive';
import 'slick-carousel';
import {Loader as GoogleMapsLoader} from 'google-maps';


document.arrive('.cmp-map', {existing: true}, function(){
    const key = $(this).data('key');
    if (!key) return;
    const mapElement = this;
    let map = null;
    const loader = new GoogleMapsLoader(key, {});
    loader.load().then(function (google) {

        //map
        map = new google.maps.Map(mapElement, {
            center: {
                lat: 45.541688342233584,
                lng: 9.337285515334266
            },
            zoom: 16,
            zoomControl: false,
            scaleControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            rotateControl: false
        });

        const marker = new google.maps.Marker({
            map,
            // icon: this.args.marker.icon + el.type + '.png',
            position: {
                lat: 45.541688342233584,
                lng: 9.337285515334266
            }
        });
    });
});